import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className"];
import React, { forwardRef } from 'react';
import { TableSectionContext } from '../utils/TableSectionContext';
import { useTableFoot } from './hooks/useTableFoot';
import { useComponentTheme } from '../../../utils/hooks';
import { useTableFootClassNames } from './hooks/useTableFootClassNames';
import { TableFootRoot } from './style';
import { tableFootRootTestId, TABLE_FOOT_CLASS_PREFIX } from './constants';
export var TableFoot = forwardRef(function TableFoot(_ref, ref) {
  var className = _ref.className,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var theme = useComponentTheme(TABLE_FOOT_CLASS_PREFIX);
  var classNameComponents = useTableFootClassNames(TABLE_FOOT_CLASS_PREFIX, className);

  var _useTableFoot = useTableFoot(),
      tableSectionContextValue = _useTableFoot.tableSectionContextValue;

  return React.createElement(TableSectionContext.Provider, {
    value: tableSectionContextValue
  }, React.createElement(TableFootRoot, Object.assign({
    "data-testid": tableFootRootTestId
  }, restProps, {
    theme: theme,
    className: classNameComponents.Root,
    ref: ref
  })));
});
TableFoot.defaultProps = {};